export default __webpack_public_path__ + "images/cf4e6be91eff4e39207fe8a0dad62274-islam_small.webp";